// FitPros Whitelabel

// for these to work, defaultEventImages must be true in projectConfig
const eventCoverPhotos = {
  default: require('./event_default.jpg'),
  'fitness-class': require('./event_fitness.jpg'),
  'health-talk': require('./event_health_talk.jpg'),
  'meditation-class': require('./event_meditation.jpg'),
  'team-building-session-cooking': require('./event_cooking.jpg'),
  'team-building-session-crafting': require('./event_crafting.jpg'),
};

export default eventCoverPhotos;
